<div class="admin-budget-history">
    <cv-loader [size]="'large'" [overlay]="false" *ngIf="isLoading"></cv-loader>
    <cv-admin-budget-title-header [title]="sectionTitle" [btnTemplate]="exportBtn"></cv-admin-budget-title-header>
    <ng-template #exportBtn>
        <div>
            <sol-button [disabled]="!(historyChartConfig && historyChartConfig.data.datasets?.length > 0)" id="export-btn" variant="basic" size="medium" [matMenuTriggerFor]="menu.menu">
                <span cvLocalizedText langSection="Budget_History" langKey="Export">Export</span>
            </sol-button>
            <sol-floating-menu #menu menuClass="export-menu-budget" [menuItems]="defaultMenuOptions" 
                        spriteIconPath="../App_Themes/CXone/icons/export-menu-icons.svg" position="'bottom'"></sol-floating-menu>
        </div>
    </ng-template>
    <div [formGroup]="budgetHistoryForm">
        <div class="row" class="admin-budget-history__date-range">
            <sol-toggle-group [class.disabled-control]="isComponentDisabled()" formControlName="dateRange" aria-label="Date range" (change)="onSelectGroup()">
                <sol-button-toggle [value]="dateRange.MONTH" [title]="dayTabName"></sol-button-toggle>
                <sol-button-toggle [value]="dateRange.YEAR" [title]="monthsTabName"></sol-button-toggle>
            </sol-toggle-group>
        </div>
        <div class="admin-budget-history__filters-container d-flex flex-row">
            <div class="admin-budget-history__filters-month"
                *ngIf="budgetHistoryForm.get('dateRange')?.value === dateRange.MONTH">
                <label cvLocalizedText langSection="Budget_History" langKey="Month">Month</label>
                <sol-dropdown id="month" name="month" formControlName="month" [optionsLabel]="'localizedName'" [class.disabled-control]="isComponentDisabled()"
                    [optionsValue]="'id'" [isMultiple]="false" [options]="months"
                    (selectionChange)="loadBudgetHistory()">
                </sol-dropdown>
            </div>
            <div class="admin-budget-history__filters-year"
                [ngClass]="{'padding-left-24': budgetHistoryForm.get('dateRange')?.value === dateRange.MONTH}">
                <label cvLocalizedText langSection="Budget_History" langKey="Year">Year</label>
                <sol-dropdown id="year" name="year" formControlName="year" [optionsLabel]="'value'" [class.disabled-control]="isComponentDisabled()"
                    [optionsValue]="'id'" [isMultiple]="false" [options]="years" (selectionChange)="loadBudgetHistory()">
                </sol-dropdown>
            </div>
            <div class="admin-budget-history__filters-group padding-left-24">
                <label>{{groupLabel}}</label>
                <sol-dropdown id="group" name="group" formControlName="group" [optionsLabel]="'GroupLevelName'" [class.disabled-control]="isComponentDisabled()"
                    [optionsValue]="'BudgetID'" [isMultiple]="false" [options]="groups"
                    (selectionChange)="onSelectGroup()">
                </sol-dropdown>
            </div>
        </div>
        <div class="admin-budget-history__chart-container d-flex flex-row">
            <div class="admin-budget-history__chart-canvas position-relative w-100 h-100">
                <canvas #canvas baseChart *ngIf="historyChartConfig && historyChartConfig.data.datasets?.length > 0"
                    [type]="historyChartConfig.type"
                    [datasets]="historyChartConfig.data.datasets"
                    [labels]="historyChartConfig.data.labels"
                    [options]="historyChartConfig.options">
                </canvas>
            </div>
        </div>
    </div>
</div>